import { Autocomplete, TextField } from "@mui/material";
import EditCoachProps from "../../../interface/editCoachProps";
import React from "react";
import { CoachListContext } from "../../../context/coachListContext";
import CoachProps from "../../../interface/coachProps";

const activeOptions: {
  label: string;
  id: number;
}[] = [
  { label: "aktiv", id: 1 },
  { label: "inaktiv", id: 0 },
];

const RenderStatusInput = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
  } = React.useContext(CoachListContext);

  return (
    <Autocomplete
      disablePortal
      disableClearable
      options={activeOptions}
      value={activeOptions.find(
        (option) => option.id === editCoach.coach.active
      )}
      sx={{ width: 200 }}
      onChange={(_event, newValue) =>
        setEditCoach({
          ...editCoach,
          coach: {
            ...editCoach.coach,
            active: newValue.id,
          },
        })
      }
      renderInput={(params) => (
        <TextField focused color="success" {...params} label="Status" />
      )}
    />
  );
};

export default RenderStatusInput;
